import { AUTH_ERROR, AUTH_USER, SET_ERROR_MESSAGE, SET_IS_P9, SET_PATIENT_TYPE } from 'helpers/types';
import { useDispatch } from 'react-redux';
import pharmacyNoBearer from 'services/pharmacyNoBearer';

export default () => {
  const dispatch = useDispatch();
  const nhsLoginToken = async (payload) => {
    try {
      const { data } = await pharmacyNoBearer.post(`/nhs-login/token`, payload);

      dispatch({ type: AUTH_USER, payload: data.access_token });
      dispatch({ type: SET_IS_P9, payload: data.patient_type === 'IM1' });
      dispatch({ type: SET_PATIENT_TYPE, payload: data.patient_type});

      return data;
    } catch (e) {
      let payload;

      if (e.response?.status === 409) {
        payload = {
          msg: 'It looks like you may already have an account.  Please contact our support team for help <a style="font-weight:500;" href="https://intercom-help.eu/heypharmacist/en" target="_blank">contact our support team here</a>',
          newMessage: true,
          link: '/pharmacy/login',
          ctaText: 'Back to NHS login',
        };
      } else if (e.response?.data?.readable_error_message) {
        payload = {
          msg: e.response.data.readable_error_message,
          newMessage: true,
          link: '/pharmacy/login',
          ctaText: 'Back to NHS login',
        };
      } else {
        payload = {
          msg: 'NHS login failed, please try again',
          newMessage: true,
          link: '/pharmacy/login',
          ctaText: 'Back to NHS login',
        };
      }

      dispatch({ type: SET_ERROR_MESSAGE, payload });
      dispatch({ type: AUTH_ERROR, payload: e });
      throw e;
    }
  };

  return [nhsLoginToken];
};
